import React from 'react'

import { Request } from 'src/types'
import SegmentControl from 'src/views/Requests/views/Form/components/Steps/Services/components/SegmentControl'

import { WrapCard } from '../../../../../styles'

import Form from './form'

type Props = {
  request: Request
}

function SearchCard({ request }: Props): JSX.Element {
  return (
    <WrapCard bodyStyle={{ minHeight: 220 }} title={<SegmentControl />}>
      <Form request={request} />
    </WrapCard>
  )
}

export default SearchCard
